import { Navigate } from "react-router-dom"
import {
  DiMaDetailsContent,
  DiMaDetailsContentProps,
} from "../../../../../../components/DiMaDetailsContent"
import { ApplicationPermissionPut } from "../../../../../../models/ApplicationPermission"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToFeature,
} from "../../../../../../models/Authorization"
import { DeviceRolePermissionGet } from "../../../../../../models/DeviceRolePermission"
import { UserInfo } from "../../../../../../models/User"

export function DeviceRolePermissionDetails(props: {
  readonly deviceRolePermission: DeviceRolePermissionGet
  readonly user: UserInfo
}) {
  const { deviceRolePermission, user } = props
  const returnURL = `/devices/${deviceRolePermission.device.id}/roles/${deviceRolePermission.role.id}#permissions`

  if (!deviceRolePermission) {
    return <Navigate to={returnURL} />
  }

  const detailsContentProps: DiMaDetailsContentProps<ApplicationPermissionPut> = {
    canWrite: hasUserAccessToFeature(
      user.authorizations,
      DimaFeatureShortNameEnum.DM,
      AccessLevel.Write
    ),
    listItems: [
      {
        id: 0,
        label: "Device",
        displayItem: <div className="title">{deviceRolePermission.device.name}</div>,
      },
      {
        id: 1,
        label: "Role",
        displayItem: <div className="title">{deviceRolePermission.role.name}</div>,
      },
      {
        id: 2,
        label: "Application",
        displayItem: <div className="title">{deviceRolePermission.application.name}</div>,
      },
      {
        id: 3,
        label: "Name",
        displayItem: <div className="title">{deviceRolePermission.permission.name}</div>,
      },
      {
        id: 4,
        label: "Description",
        displayItem: (
          <div className="title">{deviceRolePermission.permission.description}</div>
        ),
      },
    ],
  }

  return <DiMaDetailsContent {...detailsContentProps} />
}
